import React, {FC, Fragment, useEffect} from 'react';
import {connect} from "react-redux";
import CatalogBrands from "../../components/Mixer/CatalogBrands";
import {getAllBrands} from '../../modules/CatalogBrands';
import WrapperPreloader from "../../components/WrapperPreloader";
import Header from '../../components/Header';
import goBack from "../../assets/img/header/go__back.svg";
import {useHistory} from 'react-router-dom';
import {IBrands} from "../../constants/types";

interface ICatalogBrandsPage {
    isLoading: boolean,
    brands: Array<IBrands>,
    getAllBrands: any,
    getInfoBrand: any,
    tastes: Array<number>
}


const CatalogBrandsPage: FC<ICatalogBrandsPage> = ({
                                                       isLoading,
                                                       brands,
                                                       getAllBrands,
                                                       tastes
                                                   }) => {
    const history = useHistory();
    useEffect(() => {
        getAllBrands();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <Fragment>
            <WrapperPreloader
                isLoading={isLoading}
            >
                <Fragment>
                    <Header>
                        <div className="standard__header">
                            <img
                                className="standard__header-img"
                                onClick={() => history.push("/mixer")}
                                src={goBack}
                                alt="Go Back"
                            />
                            <div className="catalog-brands__text-cont">
                                <span className="header__standard-text">
                                    Каталог
                                 </span>
                            </div>
                        </div>
                    </Header>
                    <CatalogBrands
                        brands={brands}
                        tastesID={tastes}
                    />
                </Fragment>
            </WrapperPreloader>
        </Fragment>
    )
};

const mapStateToProps = (state: any) => ({
    isLoading: state.catalogBrands.isLoading,
    brands: state.catalogBrands.allBrands,
    tastes: state.tastesBrand.tastes,
});

const mapDispatchToProps = (dispatch: any) => ({
    getAllBrands: () => dispatch((getAllBrands())),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(CatalogBrandsPage);

